import React from 'react';
import CustomImage from '../../components/custom-image';
const StrongFinancial = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="two-columns">
          <div className="left-text">
            <p>
              Our operational performance, coupled with a strong focus on optimisation of capital allocation, has helped
              maintain our financial resilience. During FY2020, when it was still seen as a subdued environment for
              commodity prices, our focus on capital discipline and profitability allowed us to deliver:
            </p>
            <ul className="lists green-bullets">
              <li>Revenues of ₹83,545 crore and EBITDA of ₹21,061 crore</li>
              <li>Strong ROCE of ~11.2%</li>
              <li>
                Deleveraging and extension of our debt maturities through proactive liability management exercises
              </li>
              <li>Strong and robust FCF of ₹7,130 crore</li>
              <li>Cash and liquid investments of ₹37,914 crore</li>
              <li>
                A strong balance sheet, with respect to ND/EBITDA and gearing, compared to our global diversified peers
              </li>
              <li>Interim dividend of ~₹1,450 crores paid in FY2020</li>
            </ul>
          </div>
          <div className="right-image">
            <div className="desktop-img">
              <CustomImage className="custom-image"   imageName="investment-net-debit.png" alt="Strong Financial" maxWidth="768" />
            </div>
            <div className="mobile-img">
              <CustomImage className="custom-image"   imageName="investment-net-debit-mobile.png" alt="Strong Financial" maxWidth="768" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrongFinancial;
